// extracted by mini-css-extract-plugin
export default {"label":"textInput_label__baML4","textInput":"textInput_textInput__FroVl"};